// /audit-log — view audit-log'а собственного тенанта для OWNER (DO-7 / D18-6).
//
// Permission `distributor.audit.view` (OWNER-only) проверяется внутри
// `DistributorAuditLogScreen` (warning Banner). У PLATFORM_ADMIN'а sidebar
// этот пункт не показывает — у него отдельный /platform/audit-log.
//
// Audit follow-up (P2-C3): фильтры (actionPrefix, action, targetKind,
// actorUserId, since, until) + pagination сериализуются в URL search-params
// для shareable-ссылок и back/forward navigation. Schema через zod с safeParse
// (невалидные значения silently дропаются — фильтр просто не применяется).

import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { RequireAuth } from '@dss/auth'
import { DistributorAuditLogScreen } from '../features/audit-log/DistributorAuditLogScreen'

const auditLogSearchSchema = z
  .object({
    actionPrefix: z.string().optional(),
    action: z.string().optional(),
    targetKind: z.string().optional(),
    actorUserId: z.string().optional(),
    since: z.string().optional(),
    until: z.string().optional(),
    page: z.coerce.number().int().min(0).optional(),
    size: z.coerce
      .number()
      .int()
      .pipe(z.union([z.literal(25), z.literal(50), z.literal(100)]))
      .optional(),
  })
  .partial()

export type AuditLogSearch = z.infer<typeof auditLogSearchSchema>

export const Route = createFileRoute('/audit-log')({
  validateSearch: (search): AuditLogSearch => {
    const parsed = auditLogSearchSchema.safeParse(search)
    return parsed.success ? parsed.data : {}
  },
  component: AuditLogRoute,
})

function AuditLogRoute() {
  const search = Route.useSearch()
  return (
    <RequireAuth>
      <DistributorAuditLogScreen initialSearch={search} />
    </RequireAuth>
  )
}
